import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { lazyRoute } from '@/lib/lazy-route';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    name: 'login',
    component: lazyRoute(() => import('./views/Login.vue')),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/register',
    name: 'register',
    component: lazyRoute(() => import('./views/Register.vue')),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: lazyRoute(() => import('./views/ForgotPassword.vue')),
    meta: { public: true, layout: 'auth' },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: lazyRoute(() => import('./views/Dashboard.vue')),
  },
  {
    path: '/sales',
    name: 'sales',
    component: lazyRoute(() => import('./views/Sales.vue')),
  },
  {
    path: '/pipeline',
    name: 'pipeline',
    component: lazyRoute(() => import('./views/Pipeline.vue')),
  },
  {
    path: '/pipeline/:id',
    name: 'lead-detail',
    component: lazyRoute(() => import('./views/LeadDetail.vue')),
  },
  {
    path: '/branches/:id',
    name: 'branch-detail',
    component: lazyRoute(() => import('./views/BranchDetail.vue')),
  },
  {
    path: '/scan',
    name: 'document-scan',
    component: lazyRoute(() => import('./views/DocumentScan.vue')),
  },
  {
    path: '/stock',
    name: 'inventory',
    component: lazyRoute(() => import('./views/Inventory.vue')),
  },
  {
    path: '/reports',
    name: 'reports',
    component: lazyRoute(() => import('./views/Reports.vue')),
  },
  {
    path: '/settings',
    name: 'settings',
    component: lazyRoute(() => import('./views/Settings.vue')),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0, behavior: 'smooth' }),
});

router.beforeEach((to) => {
  const auth = useAuthStore();
  if (to.meta.public) {
    if (auth.isAuthenticated && (to.name === 'login' || to.name === 'register')) {
      return { name: 'dashboard' };
    }
    return true;
  }
  if (!auth.isAuthenticated) return { name: 'login', query: { redirect: to.fullPath } };
  return true;
});

// Final fallback — gdyby lazyRoute przepuscil chunkowy blad
router.onError((err, to) => {
  const msg = (err as Error)?.message ?? '';
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  ) {
    console.warn('Stale chunk fallback reload to', to.fullPath);
    if (typeof window !== 'undefined') {
      window.location.href = to.fullPath;
    }
  }
});
